import { createStore, combineReducers } from 'redux'

import { openModalForms, openModalCentralized } from './reducers'


const allReducers = combineReducers({
    modalForms: openModalForms,
    modalCentralized: openModalCentralized,
})

export const store = createStore(allReducers)
